module.exports = __webpack_public_path__ + "img/szystp.dc5a9b62.png";